var _circle, _circle2, _circle3, _circle4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHydrogenFrontwheels(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 510,
    height: 96,
    viewBox: "0 0 510 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 461.92,
    cy: 48.4,
    r: 42,
    fill: "#8AE0FF",
    stroke: "black",
    strokeWidth: 11.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 451.396,
    cy: 48.4,
    r: 42,
    fill: "black",
    stroke: "#8AE0FF",
    strokeWidth: 11.2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.7203,
    cy: 48.4,
    r: 42,
    fill: "#8AE0FF",
    stroke: "black",
    strokeWidth: 11.2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 48.1969,
    cy: 48.4,
    r: 42,
    fill: "black",
    stroke: "#8AE0FF",
    strokeWidth: 11.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHydrogenFrontwheels);
export default __webpack_public_path__ + "static/media/hydrogen-frontwheels.f1b8644a11d29591c8f57ef73bb5e110.svg";
export { ForwardRef as ReactComponent };